export default "__VITE_ASSET__BWHf3baT__"